import { NavLink } from 'react-router-dom';
import { Box } from '../../Core';
import { Icon, IconName } from '../../Icons';
import { IndicatorDotVariants, IndicatorDotWrapper } from '../../IndicatorDot';
import { TAB_BUTTON_SIZE, TabButtonWrapper } from './styles';
import { getEffectiveNavigationPath, type TabBarItem } from './types';

interface TabButtonProps {
  item: TabBarItem;
  isSelected: boolean;
  onPress?: () => void;
}

export function TabButton({ item, isSelected, onPress }: TabButtonProps) {
  const showIndicator = item.indicatorCount != null && item.indicatorCount > 0;
  const content = (
    <TabButtonWrapper isSelected={!!isSelected}>
      <IndicatorDotWrapper show={showIndicator} variant={IndicatorDotVariants.Notification} size={8} inset={0}>
        <Icon size={24} thin icon={item.icon ?? IconName.Table} />
      </IndicatorDotWrapper>
      <Box pt="spacingSmall" fontSize={10 / 16} data-testid={getTabLabelTestId(item)}>
        {item.label}
      </Box>
    </TabButtonWrapper>
  );

  const effectivePath = getEffectiveNavigationPath(item);

  if (effectivePath == null) {
    return (
      <button type="button" onClick={onPress} style={TAB_BUTTON_STYLE}>
        {content}
      </button>
    );
  }

  return (
    <NavLink
      key={item.id}
      to={effectivePath}
      aria-current={isSelected ? 'page' : undefined}
      onClick={onPress}
      style={TAB_BUTTON_STYLE}
    >
      {content}
    </NavLink>
  );
}

const TAB_BUTTON_STYLE = { height: TAB_BUTTON_SIZE, border: 'none', flex: 1, background: 'transparent', padding: 0 };

function getTabLabelTestId(item: TabBarItem) {
  return `mobile-tab-label-${item.id ?? item.path ?? ''}`;
}
